import { store } from '@betacrew/jars-flux'
export const componentKey = "GENERATE_SUMMARY";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setPayerList: (state, action) => {
            state.payerList = action.payload;
        },
        setFormList: (state, action) => {
            state.formList = action.payload;
        },
        setYearList: (state, action) => {
            state.yearList = action.payload;
        },
        setSelectedForm: (state, action) => {
            state.selectedForm = action.payload;
        },
        setSelectedYear: (state, action) => {
            state.selectedYear = action.payload;
        },
        setSelectedPayer: (state, action) => {
            state.selectedPayer = action.payload;
        },
        setClientPayerId: (state, action) => {
            state.clientPayerId = action.payload;
        },
        setGridData: (state, action) => {
            state.gridData = action.payload;
        }, 
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        }, 
        setSkip: (state, action) => {
            state.skip = action.payload;
        }, 
        setTotalData: (state, action) => {
            state.totalData = action.payload;
        },
        setExportFile: (state, action) => {
            state.exportFile = action.payload;
        },
        setGridSelectedForms: (state, action) => {
            state.gridSelectedForms = action.payload;
        },
    }, 
    initialReducerState: {
        loadingState: false,
        payerList: null,
        formList: null,
        yearList: null,
        selectedYear: null,
        selectedForm: null,
        selectedPayer: null,
        clientPayerId: '',
        gridData: [],
        rowsPerPage: 10,
        skip: 0,
        totalData: 0,
        exportFile: null,
        gridSelectedForms: [],
    }
});
export const { setExportFile, setTotalData, setSkip, setRowsPerPage, setGridData, setClientPayerId, setSelectedPayer, setSelectedYear, setSelectedForm, setYearList, setFormList, setPayerList, setLoadingState, setGridSelectedForms } = actions;